/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { ToolbarComponentCommonProps } from '..';
import { SearchBox } from '../../../survey-settings-toolbar/SearchBox';

export const SearchQuestions = (props: ToolbarComponentCommonProps) => {
  const { settings, handleChangeSettings } = props;

  if (!settings || !handleChangeSettings) {
    return null;
  }

  const handleTextChange = (value: string) => handleChangeSettings('searchText', value);

  return <SearchDebounce
    handleChange={handleTextChange}
    defaultValue={settings.searchText}
  />
}

interface SearchDebounceProps {
  defaultValue?: string;
  placeholder?: string;
  handleChange: (value: string) => void;
}

export const SearchDebounce = (props: SearchDebounceProps) => {
  const { defaultValue = '', handleChange, placeholder = 'Search for a metric' } = props;
  const [searchTerm, setSearchTerm] = useState<string>(defaultValue);

  const debounced = useDebouncedCallback(
    handleChange,
    500
  );

  const handleTextChange = (e: React.FormEvent<HTMLInputElement>) => {
    setSearchTerm(e.currentTarget.value);
    debounced(e.currentTarget.value);
  }

  return <SearchBox
    handleOnChange={handleTextChange}
    value={searchTerm}
    placeholder={placeholder}
  />
}
